// extracted by css-extract-rspack-plugin
var _1 = "xKSFvui1c1Q1YNDb";
var _2 = "AJGqvMVgUoIky7IL";
var _3 = "AJGqvMVgUoIky7IL";
var _4 = "LWy_a9dFQ44Q5Em9";
var _5 = "fTe9QQamjGYdrNKn";
var _6 = "fwY4Ioskt5Ekplwx";
var _7 = "fwY4Ioskt5Ekplwx";
var _8 = "tOFGiep3G09iSMeN";
export { _1 as "article", _2 as "category-box", _3 as "categoryBox", _4 as "content", _5 as "footer", _6 as "image-wrapper", _7 as "imageWrapper", _8 as "table" }
